import React from "react";
import Layout from "../../Layout";
import AddDialerUserContainer from "../../containers/AddDialerUser";
import { Helmet } from "react-helmet";

export default function AddDialerUserPage() {
  return (
    <Layout>
      <Helmet>
        <title>Add User - Dialer Settings - {process.env.REACT_APP_APP_NAME}</title>
      </Helmet>
      <AddDialerUserContainer />
    </Layout>
  );
}

